// extracted by mini-css-extract-plugin
export default {"root":"MobileModalImagesList_root__vJTlR","body":"MobileModalImagesList_body__feUL+"};